const HeatmapActionTypes = {

    GET_HEATMAP_TABLE_DATA: "GET_HEATMAP_TABLE_DATA",
    HEATMAP_TABLE_DATA: "HEATMAP_TABLE_DATA",

    GET_HEATMAP_DROPDOWN_DATA: "GET_HEATMAP_DROPDOWN_DATA",
    HEATMAP_DROPDOWN_DATA: "HEATMAP_DROPDOWN_DATA",

    UPDATE_HEATMAP_FORM_DATA_START: "UPDATE_HEATMAP_FORM_DATA_START",
    UPDATE_HEATMAP_FORM_DATA_SUCCESS: "UPDATE_HEATMAP_FORM_DATA_SUCCESS",

    GET_HEATMAP_FORM_TABLE_DATA: "GET_HEATMAP_FORM_TABLE_DATA",
    HEATMAP_FORM_TABLE_DATA: "HEATMAP_FORM_TABLE_DATA",

    GET_VISHING_DROPDOWN_DATA: "GET_VISHING_DROPDOWN_DATA",
    VISHING_DROPDOWN_DATA: "VISHING_DROPDOWN_DATA",

    UPDATE_VISHING_FORM_DATA_START: "UPDATE_VISHING_FORM_DATA_START",
    UPDATE_VISHING_FORM_DATA_SUCCESS: "UPDATE_VISHING_FORM_DATA_SUCCESS",

    GET_VISHING_FORM_TABLE_DATA: "GET_VISHING_FORM_TABLE_DATA",
    VISHING_FORM_TABLE_DATA: "VISHING_FORM_TABLE_DATA",

    GET_VISHING_VALIDATE_TICKET_NO: "GET_VISHING_VALIDATE_TICKET_NO",
    VISHING_VALIDATE_TICKET_NO: "VISHING_VALIDATE_TICKET_NO",



};
export default HeatmapActionTypes;